import axios from "axios";
import Cookie, { removeSession } from "../utilities/CookieUtility";

axios.interceptors.response.use(
  (res) => {
    return res;
  },
  (err) => {
    if (err.response && err.response.data.message === "bad token")
      removeSession();
    return err;
  }
);

const GetLocal = async (url) => {
  let token = Cookie.get("auth");
  return await axios({
    method: "get",
    url: process.env.REACT_APP_BACKEND_HOST_LOCAL + url,
    headers: {
      "Content-Type": "application/json",
      "Access-Control-Allow-Origin": "*",
      Authorization: `Bearer ${token}`,
    },
  });
};

const Get = async (url) => {
  return await axios({
    method: "get",
    url: process.env.REACT_APP_BACKEND_HOST_DSPACE + url,
    headers: {
      "Content-Type": "application/json",
      "Access-Control-Allow-Origin": "*",
    },
  });
};

const PostLocal = async (url, data = {}) => {
  let token = Cookie.get("auth");
  console.log(process.env.REACT_APP_BACKEND_HOST_LOCAL);
  return await axios({
    method: "post",
    url: process.env.REACT_APP_BACKEND_HOST_LOCAL + url,
    data: data,
    headers: {
      "Content-Type": "application/json",
      "Access-Control-Allow-Origin": "*",
      Authorization: `Bearer ${token}`,
    },
  });
};

const Post = async (url, data = {}) => {
  let token = Cookie.get("auth");
  return await axios({
    method: "post",
    url: process.env.REACT_APP_BACKEND_HOST_LOCAL + url,
    data: data,
    headers: {
      "Content-Type": "application/json",
      "Access-Control-Allow-Origin": "*",
      Authorization: `Bearer ${token}`,
    },
  });
};

const PostFile = async (url, formData) => {
  let token = Cookie.get("auth");
  return await axios({
    method: "post",
    url: process.env.REACT_APP_BACKEND_HOST_DSPACE + url,
    data: formData,
    headers: {
      "Content-Type": "multipart/form-data",
      "Access-Control-Allow-Origin": "*",
      Authorization: `Bearer ${token}`,
    },
  });
};

const PostDirect = async (url, data = {}, headers = {}) => {
  //data.token = Cookie.get('auth')
  return await axios({
    method: "post",
    url: url,
    data: data,
    headers: headers,
  });
};

export { Get, Post, PostDirect, PostFile, GetLocal, PostLocal };
